import { lazy, Suspense } from 'react'
import Spinner from '@wiggui/ds/Spinnner'
import { Skeleton } from '@wiggui/ds/Skeleton'
import { composeClasses } from '@wiggot/utils/src/strings'
import IconWiggot from '@wiggui/ds/IconWiggot'
import { NewIconBlackWiggot } from './assets/NewIconBlackWiggot'

const MenuOptions = lazy(() => import('./components/MenuOptions'))
const MenuMobile = lazy(() => import('./mobile/MenuMobile'))

export const SkeletonMenuOptions = ({ className }: { className?: string }) => {
  return (
    <div
      className={composeClasses(
        'py-3 px-2 h-full ui-kit-scrollbar overflow-y-auto overflow-x-hidden hidden md:block menu-header--expanded',
        className
      )}
    >
      <div className="flex flex-col gap-4 w-full h-full items-stretch">
        <div className="w-full flex flex-row items-center justify-start gap-1 px-1.5 pt-3 pb-6 min-h-[68px]">
          <div className="w-full flex flex-row items-center justify-start gap-1">
            <div className="w-full flex flex-row items-center justify-start gap-2">
              <IconWiggot variant="black" height="24px" />
              <div className="w-fit h-full flex items-center pt-1">
                <NewIconBlackWiggot />
              </div>
            </div>
          </div>
          <div className="rounded-xl min-w-[32px] min-h-[32px] max-w-[32px] flex items-center justify-center max-h-[32px]">
            <Spinner />
          </div>
        </div>
        <ul className="flex flex-col w-full min-h-fit mb-4">
          {[1, 2, 3, 4, 5, 6].map((value) => {
            return (
              <li
                key={value}
                className="flex flex-col items-baseline gap-1 h-10 w-[176px] px-[10px] list-none"
              >
                <div className="flex w-full gap-3 flex-row items-center justify-start">
                  <Skeleton
                    width="w-[18px]"
                    height="h-[18px]"
                    className="bg-white"
                  />
                  <Skeleton
                    width="w-fit"
                    height="h-[20px]"
                    className="flex-1 bg-white"
                  />
                </div>
              </li>
            )
          })}
        </ul>
        <div className="flex flex-col min-h-[136px] items-start justify-center gap-2 w-full mt-auto">
          <div className="flex justify-between w-full items-center gap-2.5 h-10 min-h-[40px] px-[10px] rounded-xl bg-surface-gray-10">
            <div className="flex w-full gap-3 flex-row items-center justify-start">
              <Skeleton width="w-[18px]" height="h-[18px]" />
              <Skeleton width="w-fit" height="h-[20px]" className="flex-1" />
            </div>
          </div>
          <div className="flex justify-between w-full items-center gap-2.5 h-10 min-h-[40px] px-[10px] rounded-xl bg-surface-gray-10">
            <div className="flex w-full gap-3 flex-row items-center justify-start">
              <Skeleton width="w-[18px]" height="h-[18px]" />
              <Skeleton width="w-fit" height="h-[20px]" className="flex-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const SkeletonMenuMobile = ({ className }: { className?: string }) => {
  return (
    <div
      className={composeClasses(
        'fixed bottom-0 max-w-[100dvw] px-3 z-3 md:hidden w-full bg-surface-white border-t border-t-surface-strokes',
        className
      )}
    >
      <div className="flex flex-row items-center justify-around gap-0 w-full">
        {[1, 2, 3, 4, 5].map((value) => {
          return (
            <div
              key={value}
              className="flex flex-col items-center justify-center py-1.5 w-full"
            >
              <div className="w-9 h-9 rounded-xl border flex items-center justify-center border-transparent">
                <Skeleton width="w-[21px]" height="h-[21px]" />
              </div>
              <Skeleton width="w-10" height="h-[14px]" />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const NavbarV2 = ({ className }: { className?: string }) => {
  return (
    <>
      <Suspense fallback={<SkeletonMenuMobile />}>
        <MenuMobile className={className} />
      </Suspense>
      <Suspense fallback={<SkeletonMenuOptions />}>
        <MenuOptions className={className} />
      </Suspense>
    </>
  )
}
